import { DebouncedTextInput, Toolbar } from "ra-friendsofbabba";
import {
  NumberInput,
  SimpleForm,
  maxValue,
  minValue,
  required,
} from "react-admin";

import PatentStatusInput from "./inputs/PatentStatusInput";
import PatentTypeInput from "./inputs/PatentTypeInput";
import PatentTypeOtherInput from "./inputs/PatentTypeOtherInput";
import React from "react";
import moment from "moment";

const Form = ({ type, ...props }) => {
  const year = moment().format("YYYY");
  return (
    <SimpleForm
      {...props}
      initialValues={{ year }}
      toolbar={
        <Toolbar
          backTab={3}
          backReference="research-projects"
          backReferenceTarget="research_project_id"
        />
      }
    >
      <DebouncedTextInput
        source="title"
        fullWidth
        validate={required()}
        maxLength={250}
      />
      <PatentStatusInput source="patent_status_id" validate={required()} />

      <NumberInput
        source="year"
        validate={[required(), minValue(1950), maxValue(2022)]}
      />
      <PatentTypeInput source="patent_type_id" validate={required()} />
      <PatentTypeOtherInput source="patent_type_other" />
      <DebouncedTextInput
        source="tech_class"
        validate={[required()]}
        maxLength={500}
        fullWidth
        multiline
      />
      <DebouncedTextInput
        source="inventors"
        validate={[required()]}
        maxLength={500}
        fullWidth
        multiline
      />
      <DebouncedTextInput
        source="owners"
        validate={[required()]}
        maxLength={500}
        fullWidth
        multiline
      />
    </SimpleForm>
  );
};
export default Form;
